
import { defineComponent, onMounted, computed, ref } from 'vue'
import { Search } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'
import { useStore } from '@/store/index'
import { addSearchQuery } from '@/types/forms/search-word'
import { mdiMagnify } from '@mdi/js'

interface RestaurantItem {
  value: string
}

export default defineComponent({
  setup(){
    const focusSearch = ref<HTMLImageElement>()
    const store = useStore()
    const router = useRouter()
    const search_word = computed<string>({
      get() {
        return store.getters['search/getSearchWord']
      },
      set(value) {
        store.commit('search/setSearchWord', value)
      }
    })
    const restaurants = computed(() => {return store.getters['layout/getSuggests']})
    const querySearch = (queryString: string, cb: any) => {
      const results = queryString
        ? restaurants.value.filter(createFilter(queryString))
        : []
      cb(results)
    }
    const createFilter = (queryString: string) => {
      return (restaurant: RestaurantItem) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1
        )
      }
    }

    const onFocus = () => { 
      if (!store.state.layout.pcSearching.on && !store.state.base.responsive.isSM){
        store.dispatch('layout/switchsearchHistoryOpen')
        store.dispatch('layout/pcSearchingOn')
      }
    }

    const onSearch = (async() => {
      store.dispatch('layout/pcSearchingOff')
      if (store.state.layout.searchHistory.open){
        store.dispatch('layout/switchsearchHistoryOpen')
      }
      if (search_word.value){
        store.dispatch('search/postSearch', search_word.value)
          .then(() => {
            store.dispatch('search/fetchSearchHistories')
          })
          .catch((err) =>{
            console.log(err)
          })
        await router.push({ path: '/video', query: addSearchQuery(search_word.value) })
      } else {
        router.push({ path: '/video' })
      }
    })

    const onSuggestSearch = (async(suggestWord:string) => {
      store.dispatch('layout/pcSearchingOff')
      if (store.state.layout.searchHistory.open){
        store.dispatch('layout/switchsearchHistoryOpen')
      }
      store.dispatch('search/postSearch', suggestWord)
        .then(() => {
          store.dispatch('search/fetchSearchHistories')
        })
        .catch((err) =>{
          console.log(err)
        })
      await router.push({ path: '/video', query: addSearchQuery(suggestWord) })
    })

    onMounted(async() => {
      await store.dispatch('layout/fetchSuggests')
      store.dispatch('search/fetchSearchWord')
      if (store.state.base.responsive.isSM){
        focusSearch.value?.focus()
      }
    })

    return {
      Search,
      onSearch,
      onSuggestSearch,
      querySearch,
      search_word,
      mdiMagnify,
      onFocus,
      store,
      focusSearch
    }
  }
})
